import React  from 'react';
import { Modal } from '@carbon/react';

const CloseUnsavedFormConfirmationModal = ({ next = () => {}, hideModal}) => {
  return (
    <Modal
      open={true}
      danger={true}
      size="sm"
      primaryButtonText="Fortfahren"
      secondaryButtonText="Abbrechen"
      modalHeading="Es gibt noch ungespeicherte Änderungen, soll das Formular wirklich geschlossen werden?"
      onRequestClose={hideModal}
      onRequestSubmit={() => {
        hideModal();
        next();
      }}></Modal>
  );
};

export default CloseUnsavedFormConfirmationModal;
